import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "sparkwear_cart_v1";
const lineKey = (i) => `${i.productId}:${i.size}:${i.colour || ""}`;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (item) =>
    setItems((prev) => {
      const found = prev.find((p) => lineKey(p) === lineKey(item));
      if (found)
        return prev.map((p) =>
          lineKey(p) === lineKey(item) ? { ...p, qty: p.qty + 1 } : p
        );
      return [...prev, { ...item, qty: 1 }];
    });

  const setQty = (productId, size, qty, colour = "") =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((p) => !(p.productId === productId && p.size === size && (p.colour || "") === colour))
        : prev.map((p) =>
            p.productId === productId && p.size === size && (p.colour || "") === colour ? { ...p, qty } : p
          )
    );

  const removeItem = (productId, size, colour = "") =>
    setItems((prev) =>
      prev.filter((p) => !(p.productId === productId && p.size === size && (p.colour || "") === colour))
    );

  const clear = () => setItems([]);

  const count = items.reduce((s, p) => s + p.qty, 0);
  const subtotal = items.reduce((s, p) => s + p.qty * p.price, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, setQty, removeItem, clear, count, subtotal }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
